import React from 'react'
import {ModeleSavReferentiel} from '../../../../components/sav/Models'
import {SAV_SOURCE_ICONES} from '../../../../components/sav/libelles'

// Icône verte du canal d'arrivée de la réclamation
const SavSourceIcone = ({source}: {source?: ModeleSavReferentiel | null}) => (
  <i
    className={`bi ${
      SAV_SOURCE_ICONES[source?.comportement ?? ''] ?? 'bi-question-circle'
    } fs-3 text-success`}
    title={source?.libelle}
  ></i>
)

export default SavSourceIcone
